import { HttpContextToken } from '@angular/common/http';

export const CACHING_ENABLED = new HttpContextToken<boolean>(() => false);
export const CACHE_TTL = new HttpContextToken<number>(() => 30000);
